/**
 * Soi ảnh mà một trang HTML đang cần.
 *
 * Vì sao cần: HTML admin dán vào trỏ sẵn <img src=".../img/pages/ten-anh.webp">, nhưng
 * file ảnh có nằm trên server hay chưa thì nhìn code không biết — deploy KHÔNG đẩy
 * thư mục src/public/img nên rất dễ lên trang mà vỡ hết ảnh (đúng ca 20/08/2026).
 *
 * Kiểm tra bằng thẻ <img> chứ không fetch: ảnh nằm khác origin với admin nên fetch
 * sẽ vướng CORS, còn <img> thì trình duyệt cho tải thoải mái.
 */

/** Tên file ảnh mà backend sẽ đặt cho file admin chọn — khớp uploadController. */
export function toPageImageName(fileName) {
    const base = String(fileName || "")
        .replace(/\.[^.]+$/, "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[đĐ]/g, "d")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .slice(0, 80);
    return `${base || "page"}.webp`;
}

/**
 * Mọi ảnh /img/pages/... mà HTML đang tham chiếu (đã bỏ trùng, giữ thứ tự xuất hiện).
 * @returns {Array<{name: string, url: string}>}
 */
export function extractPageImages(html) {
    const found = new Map();
    // Bắt cả src="..." lẫn url(...) trong <style>, cả tuyệt đối lẫn tương đối.
    const pattern = /(?:src\s*=\s*["']|url\(\s*["']?)([^"')\s]*\/img\/pages\/([^"')\s?#]+))/gi;
    let match = pattern.exec(html || "");
    while (match) {
        const [, url, name] = match;
        if (!found.has(name)) found.set(name, url);
        match = pattern.exec(html || "");
    }
    return Array.from(found, ([name, url]) => ({ name, url }));
}

/** Ảnh tải được không. Trả về Promise<boolean>, không bao giờ reject. */
export function imageExists(url) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        // Chống cache trình duyệt nhớ bản 404 của lần kiểm trước khi vừa upload xong.
        img.src = `${url}${url.includes("?") ? "&" : "?"}_probe=${Date.now()}`;
    });
}

/**
 * Kiểm tra cả danh sách.
 * @returns {Promise<Record<string, boolean>>} map tên file → có trên server chưa
 */
export async function probePageImages(images) {
    const results = await Promise.all(images.map((i) => imageExists(i.url)));
    return Object.fromEntries(images.map((img, i) => [img.name, results[i]]));
}
